import { useTranslation } from 'react-i18next';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { MdOutlineCancel } from 'react-icons/md';
function ExtensiveCoverage(props) {
  const { extensiveCoverageRef } = props;
  const { t } = useTranslation();
  return (
    <div className="w-full py-[6.25rem] " ref={extensiveCoverageRef}>
      <div className="w-10/12 m-auto">
        <div className="mb-[3.12rem]">
          <h2 className="text-primary font-bold text-[1.87rem]">{t('extensiveCoverage.title')}</h2>
        </div>
        <div className="overflow-x-scroll">
          <table id="extensive-coverage" className="m-auto">
            <thead>
              <tr className="border-t border-secondary">
                <th className=" p-[1.87rem] text-center max-w-[13.25rem] w-[12.5rem]"></th>
                <th className=" p-[1.87rem] text-center max-w-[13.25rem] w-[12.5rem]">
                  {t('extensiveCoverage.civilLiability')}
                </th>
                <th className=" p-[1.87rem] text-center max-w-[13.25rem] w-[12.5rem]">
                  {t('extensiveCoverage.fullOmnium')}
                </th>
                <th className=" p-[1.87rem] text-center max-w-[13.25rem] w-[12.5rem]">
                  {t('extensiveCoverage.equipmentCoverage')}
                </th>
                <th className=" p-[1.87rem] text-center max-w-[13.25rem] w-[12.5rem]">
                  {t('extensiveCoverage.legalCounsel')}
                </th>
                <th className=" p-[1.87rem] text-center max-w-[13.25rem] w-[12.5rem]">
                  {t('extensiveCoverage.assistance')}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field1')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field2')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center"> {t('extensiveCoverage.field3')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field4')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field5')}</td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.worldwide')}</td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field6')}</td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field7')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field8')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <IoIosCheckmarkCircleOutline className=" text-[#54AF80] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
              </tr>
              <tr className="border-t border-secondary">
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.field9')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.limited')}</td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">
                  <MdOutlineCancel className=" text-[#FC2C38] text-[1.75rem] m-auto" />
                </td>
                <td className=" p-[1.87rem] text-center">{t('extensiveCoverage.extensive')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default ExtensiveCoverage;
